// extracted by mini-css-extract-plugin
export default {"container":"style_container__MxQ4D","header":"style_header__XKb2L","content":"style_content__sAKNe","questions":"style_questions__yXVws"};